export class UrlUtils {
  public static getDateAsPath(date: Date): string {
    return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
  }

  public static dateRemoveTime(date: Date): Date {
    date.setMilliseconds(0);
    date.setSeconds(0);
    date.setMinutes(0);
    date.setHours(0);

    return date;
  }

  public static dateUTCToLocale(date: Date, fix?: number | undefined): Date {
    const newDate = new Date(
      date.getTime() + date.getTimezoneOffset() * 60 * 1000 + fix!
    );
    const offset = date.getTimezoneOffset() / 60;
    const hours = date.getHours();
    newDate.setHours(hours - offset);
    return newDate;
  }
}
